export default __webpack_public_path__ + "static/media/mini-logo-mob.502d95ed.png";